import request from '@/utils/request'

// 获取租户列表
export function getTenantList(params) {
  return request({
    url: '/tenant/list',
    method: 'get',
    params
  })
}

// 添加租户
export function addTenant(data) {
  return request({
    url: '/tenant/add',
    method: 'post',
    data
  })
}

// 更新租户
export function updateTenant(data) {
  return request({
    url: '/tenant/update',
    method: 'put',
    data
  })
}

// 删除租户
export function deleteTenant(tenantId) {
  return request({
    url: `/tenant/delete/${tenantId}`,
    method: 'delete'
  })
}

// 获取租户详情
export function getTenantById(tenantId) {
  return request({
    url: `/tenant/${tenantId}`,
    method: 'get'
  })
} 